<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Actividades por periodo</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>
            <b-col sm="3">
              <b-form-group :label="crearLabel('Fecha Desde', 'fdesde', 'datosFormulario')"
                          label-for="fdesde" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fdesde"
                          :disabled="campoBloqueado('fdesde', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fdesde }}
                  </span>
                  </b-input-group>
              </b-form-group>    
            </b-col>

            <b-col sm="3" >  
              <b-form-group :label="crearLabel('Fecha Hasta', 'fhasta', 'datosFormulario')"
                          label-for="fhasta" :horizontal="false" >
                  <b-input-group>
                      <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                      <datepicker 
                          :language="es" 
                          format="dd/MM/yyyy"
                          :use-utc="true"
                          input-class="form-control" 
                          v-model="datosFormulario.fhasta"
                          :disabled="campoBloqueado('fhasta', 'datosFormulario')">
                      </datepicker>
                  <span class="error-validacion-campo">
                      {{ mensajeValidacionCampo.fhasta }}
                  </span>
                  </b-input-group>
              </b-form-group>    

            </b-col>
            <b-col sm="6">  
                <b-form-group
                    :label="crearLabel('Tareas', 'tareas', 'datosFormulario')"
                    label-for="tareas">
                    <multiselect 
                        v-model="value" 
                        tag-placeholder="Seleccionar tarea" 
                        placeholder="Buscar tarea" 
                        label="name" 
                        track-by="code" 
                        :options="valTareas" 
                        :multiple="true" 
                        :taggable="true" 
                        @tag="addTag">
                    </multiselect>
                    <span class="error-validacion-campo">
                    {{ mensajeValidacionCampo.tarea }}
                    </span>
                </b-form-group>
           </b-col>  
             
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cantidad de tareas asignadas por ejecutivos en el periodo</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Cantidad de tareas completadas por asistentes en el periodo</strong>
          </div>
          <b-row>
            <b-col lg="6">
              
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters2[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data2"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters2"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titlesDinamic2"
                  :prop="title.prop"
                  :min-width="title.minwidth"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>

      
      </b-col>
    </b-row>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInformes from "@/components/services/apiInformes";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "ActividadesPorPeriodo",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      data2: [],
      nombreexcel: "ActividadesPorPeriodo",
      titlesDinamic: [],
      filters: [
        {
          prop: [],
          value: ""
        }
      ],
      titlesDinamic2: [],
      filters2: [
        {
          prop: [],
          value: ""
        }
      ],
      
      datosFormulario: {},
      valTareas: [],
      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: true,
          maxHeight: 400
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    cargarColumnasGrilla(data){
      this.titlesDinamic = [];
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Tarea/Ejecutivo"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic.push(arrAux);
              this.filters[0].prop.push(key2);    
          }
          return;
      }
          
    },

    cargarColumnasGrilla2(data){
      this.titlesDinamic2 = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              let arrAux = [];
              arrAux["prop"] = key2;
              arrAux["label"] = key2.replace("'","").replace("'","");
              arrAux["align"] = "left";
              if (key2 != "Tarea/Asistente"){
                arrAux["align"] = "right";
              }
              this.titlesDinamic2.push(arrAux);
              this.filters2[0].prop.push(key2);       
          }
          return;
      }
          
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.value = null;

      return apiInformes
        .pre_insercion_totaltareaactiv(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fdesde = lista_data[i]["fdesde"];
              this.datosFormulario.fhasta = lista_data[i]["fhasta"];
          }
          
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de tareas
          var tiposTareas = new Array();
          var lista_tipos_tareas = response.data.tareas;
          for(var i = 0; i < lista_tipos_tareas.length; i++){
              var obj = new Object();
              obj.name = lista_tipos_tareas[i]["destarea"];
              obj.code = lista_tipos_tareas[i]["codtarea"];
              tiposTareas.push(obj);
          }
          this.valTareas = tiposTareas;

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      //Carga lista de tareas
      if (this.value != null && this.value != ""){
        var seleccionTareas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionTareas += "," + this.value[i]["code"];
        }
        seleccionTareas = seleccionTareas.substring(1,seleccionTareas.length);
      }else{
        seleccionTareas = "0";
      }
      
      return apiInformes
        .recuperar_totaltareaactiv(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fdesde, 
          this.datosFormulario.fhasta, 
          seleccionTareas
        )
        .then(response => {
          this.data  = response.data.res1;
          this.data2  = response.data.res2;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          if (this.data != null){
            this.exportar = true;
          } else {
            this.exportar = false;
          }
          

          this.cargarColumnasGrilla(this.data);
          this.cargarColumnasGrilla2(this.data2);
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      
      if (((column.property != "Tarea/Ejecutivo" &&
           column.property != "Tarea/Asistente")) && 
           row[column.property]) {
        column.align = "is-right";
        
        return this.$numeral(row[column.property]).format();
      } else {
        return row[column.property];
      }
      
    },

    cargarColumnasDinamicas(data){
      var titlesDinamic = [];
      
      for (var key in data) {
          for (var key2 in data[key]) {
              titlesDinamic.push(key2);     
          }
          return titlesDinamic;
      }
      
    },

    descargarExcel: function(){
      var cuerpo = "";
      var columnas = this.cargarColumnasDinamicas(this.data);

      //Carga lista de tareas
      if (this.value != null && this.value != ""){
        var seleccionTareas = "";
        for(var i = 0; i < this.value.length; i++){
          seleccionTareas += "," + this.value[i]["name"];
        }
        seleccionTareas = seleccionTareas.substring(1,seleccionTareas.length);
      }else{
        seleccionTareas = "Todas";
      }

      var xl159618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 = "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 = "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      //titulo general
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Actividades por periodo</td>\n";
      cuerpo += "</tr>\n";
      
      //subtitulo general
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Desde "+this.convierteFecha(this.datosFormulario.fdesde)+" Hasta "+this.convierteFecha(this.datosFormulario.fhasta)+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td height=28 class=xl159618 width=32 style='height:21.0pt;width:24pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 width=698 style='width:526pt;"+xl689618+"'>Tareas: "+seleccionTareas+"</td>\n";
      cuerpo += "</tr>\n";


      //seperador
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
          cuerpo += "<td colspan="+(columnas.length+1)+"></td>\n";
      cuerpo += "</tr>\n";

      //Titulos columnas bloque 1
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Cantidad de tareas asignadas por ejecutivos en el periodo</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 1
      var sumdata = [];
      for (var i=1; i<columnas.length; i++) {
        sumdata[columnas[i]] = 0;
      }

      for (var key in this.data) {          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            for (var i=0; i<columnas.length; i++) {
              if (i > 0){
                sumdata[columnas[i]] += this.data[key][columnas[i]];
              }
              cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data[key][columnas[i]]+"</td>\n";
            }
          cuerpo += "</tr>\n";
      }
      
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td>&nbsp</td>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
        for (var i=1; i<columnas.length; i++) {
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata[columnas[i]]+"</td>\n";
        }
      cuerpo += "</tr>\n";


      columnas = this.cargarColumnasDinamicas(this.data2);
      //seperador
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
          cuerpo += "<td colspan="+(columnas.length+1)+"></td>\n";
      cuerpo += "</tr>\n";

      //Titulos columnas bloque 2
      cuerpo += "<tr height=26 style='mso-height-source:userset;height:19.5pt'>\n";
        cuerpo += "<td height=26 class=xl159618 style='height:19.5pt;"+xl159618+"'></td>\n";
        cuerpo += "<td colspan="+columnas.length+" class=xl689618 style='border-right:.5pt solid black;"+xl689618+"'>Cantidad de tareas completadas por asistentes en el periodo</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
        for (var i=0; i<columnas.length; i++) {
          cuerpo += "<td class=xl679618 style='border-left:none;"+xl679618+"'>"+columnas[i]+"</td>\n";
        }
      cuerpo += "</tr>\n";


      //Data bloque 2
      var sumdata = [];
      for (var i=1; i<columnas.length; i++) {
        sumdata[columnas[i]] = 0;
      }

      for (var key in this.data2) {          
          cuerpo += "<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
            cuerpo += "<td>&nbsp</td>\n";
            for (var i=0; i<columnas.length; i++) {
              if (i > 0){
                sumdata[columnas[i]] += this.data2[key][columnas[i]];
              }
              cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"'>"+this.data2[key][columnas[i]]+"</td>\n";
            }
          cuerpo += "</tr>\n";
      }
      
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
        cuerpo += "<td>&nbsp</td>\n";
        cuerpo += "<td height=20 class=xl659618 style='height:15.0pt;border-top:none;border-left: none;"+xl659618+"'>Total</td>\n";
        for (var i=1; i<columnas.length; i++) {
          cuerpo += "<td class=xl659618 align=right style='border-top:none;border-left:none;"+xl659618+"'>"+sumdata[columnas[i]]+"</td>\n";
        }
      cuerpo += "</tr>\n";
      
      this.export(this.generaExcelV2(this.nombreexcel, cuerpo),this.nombreexcel);
    },

    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.buscar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}
</style>
